module.exports = __webpack_public_path__ + "img/transparent-acrylic-paperweight.771dde90.jpeg";